import {inject, injectable} from 'inversify';

import type {MembershipModel} from '../../domain/Membership/Membership.model';

import {alert} from '../../../components/alert';
import {AppError} from '../../../utils/errors/app';
import {ToggleEmployeeSubscriptionCmd} from '../../ports/Membership/ToggleEmployeeSubscription/ToggleEmployeeSubscription.cmd';
import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';

@injectable()
export class ToggleEmployeeSubscriptionUseCase {
  constructor(
    @inject(ToggleEmployeeSubscriptionCmd)
    private readonly toggleSubscription: ToggleEmployeeSubscriptionCmd,
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  async exec(
    props: ToggleEmployeeSubscriptionUseCase.Props,
  ): Promise<ToggleEmployeeSubscriptionUseCase.Response> {
    const {course, membership} = await this.toggleSubscription.exec(props);

    const target = this.modelsRegistry.get<MembershipModel>(membership.id);

    if (target) {
      target.update(membership);
      target.course?.update(course);
    } else {
      const error = new AppError('Membership is not found');

      alert.error(error);

      throw error;
    }
  }
}

export namespace ToggleEmployeeSubscriptionUseCase {
  export type Props = ToggleEmployeeSubscriptionCmd.Props;
  export type Response = undefined;
}
